export const initialCartState = {
  addOrderToCart: {
    loading: false,
    data: {},
    error: '',
  },
  cartDetails: {
    loading: false,
    data: {},
    error: '',
  },
  removeCartItem: {
    loading: false,
    data: {},
    error: '',
  },
  cartCheckout: {
    loading: false,
    data: {},
    error: '',
  },
};
